function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 10a4 4 0 01-4 4H5a3 3 0 00-2.15.85l-2 2A.49.49 0 01.5 17a.5.5 0 01-.5-.5V4a4 4 0 014-4h10a4 4 0 014 4v6zM2 4v9a5 5 0 013-1h9a2 2 0 002-2V4a2 2 0 00-2-2H4a2 2 0 00-2 2zm10.5 4h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5zm-3 0h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5zM6 7.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5zM16 16a4 4 0 004-4V4a2 2 0 011.98 2v14.53a.5.5 0 01-.5.5.49.49 0 01-.35-.15l-2-2A3 3 0 0017 18H6a2 2 0 01-2-2h12z"
});

var SvgSmsChatOutlined = function SvgSmsChatOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 22 22",
    fill: "#fff"
  }, props), _ref);
};

export default SvgSmsChatOutlined;